// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-container {
  min-height: 100vh;
  background: #161F32;
  position: relative;
  overflow: hidden;
  padding: 0;
}
.hero-container::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='1' fill='rgba(255,255,255,0.1)'/%3E%3C/svg%3E");
  opacity: 0.3;
  animation: float 20s linear infinite;
}

.hero-section {
  background: #161F32;
  min-height: 100vh;
  width: 100%;
}

.hero-content {
  padding: 4rem 2rem;
  color: white;
  position: relative;
  z-index: 1;
}
.hero-content .badge-wrapper {
  margin-bottom: 2rem;
}
.hero-content .badge-wrapper .badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2rem;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  font-size: 0.9rem;
}
.hero-content .badge-wrapper .badge ion-icon {
  color: #60a5fa;
}
.hero-content .main-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1.5rem;
}
.hero-content .main-title .highlight {
  background: linear-gradient(120deg, #60a5fa, #818cf8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.hero-content .subtitle {
  font-size: 1.2rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2.5rem;
  max-width: 600px;
}
.hero-content .features-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 3rem;
}
.hero-content .features-list .feature-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.hero-content .features-list .feature-item .check-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(96, 165, 250, 0.2);
  border-radius: 50%;
}
.hero-content .features-list .feature-item .check-icon ion-icon {
  color: #60a5fa;
  font-size: 1rem;
}
.hero-content .cta-group {
  display: flex;
  gap: 1rem;
  margin-bottom: 3rem;
}
.hero-content .cta-group .primary-btn {
  --background: #60a5fa;
  --padding-start: 2rem;
  --padding-end: 2rem;
  --border-radius: 2rem;
  height: 3.5rem;
  font-weight: 600;
}
.hero-content .cta-group .primary-btn ion-icon {
  margin-right: 0.5rem;
}
.hero-content .cta-group .secondary-btn {
  --background: rgba(255, 255, 255, 0.1);
  --padding-start: 2rem;
  --padding-end: 2rem;
  --border-radius: 2rem;
  height: 3.5rem;
  font-weight: 600;
}
.hero-content .cta-group .secondary-btn ion-icon {
  margin-right: 0.5rem;
}
.hero-content .stats-container {
  display: flex;
  align-items: center;
  gap: 2rem;
}
.hero-content .stats-container .stat-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.hero-content .stats-container .stat-item .stat-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #60a5fa;
}
.hero-content .stats-container .stat-item .stat-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
}
.hero-content .stats-container .stat-item .rating {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.hero-content .stats-container .stat-item .rating ion-icon {
  color: #fbbf24;
}
.hero-content .stats-container .stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
}

.visual-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
}
.visual-container .app-preview {
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 500px;
}
.visual-container .phone-frame {
  height: 100%;
  background: white;
  border-radius: 3rem;
  padding: 1rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.visual-container .phone-frame .screen {
  background: #f8fafc;
  border-radius: 2.5rem;
  overflow: hidden;
  padding: 1rem;
}
.visual-container .phone-frame .screen .app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.visual-container .phone-frame .screen .app-header .status-icons {
  display: flex;
  gap: 0.5rem;
  color: #64748b;
}
.visual-container .phone-frame .screen .app-content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.visual-container .phone-frame .screen .app-content .session-card {
  background: white;
  border-radius: 1.5rem;
  padding: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.visual-container .phone-frame .screen .app-content .session-card .user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.visual-container .phone-frame .screen .app-content .session-card .user-info .avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #60a5fa;
}
.visual-container .phone-frame .screen .app-content .session-card .user-info .details {
  flex: 1;
}
.visual-container .phone-frame .screen .app-content .session-card .user-info .details h3 {
  font-weight: 600;
  margin: 0;
}
.visual-container .phone-frame .screen .app-content .session-card .user-info .details p {
  color: #64748b;
  font-size: 0.9rem;
  margin: 0;
}
.visual-container .phone-frame .screen .app-content .session-card .user-info .progress {
  font-weight: 700;
  color: #60a5fa;
}
.visual-container .phone-frame .screen .app-content .session-card .session-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
.visual-container .phone-frame .screen .app-content .session-card .session-stats .stat {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #64748b;
}
.visual-container .phone-frame .screen .app-content .session-card .session-stats .stat ion-icon {
  color: #60a5fa;
}
.visual-container .floating-elements {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.visual-container .floating-elements .float-card {
  position: absolute;
  background: white;
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  animation: float 6s ease-in-out infinite;
}
.visual-container .floating-elements .float-card.progress-card {
  top: 20%;
  right: -20px;
  animation-delay: 0s;
}
.visual-container .floating-elements .float-card.notification-card {
  top: 50%;
  left: -20px;
  animation-delay: 2s;
}
.visual-container .floating-elements .float-card.schedule-card {
  bottom: 20%;
  right: -20px;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
.social-links {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 3rem;
}
.social-links .social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}
.social-links .social-link ion-icon {
  font-size: 1.25rem;
  color: white;
}
.social-links .social-link:hover {
  background: #60a5fa;
  transform: translateY(-3px);
}

.social-links-bottom {
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 1000;
}
.social-links-bottom .social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.social-links-bottom .social-link ion-icon {
  font-size: 1.25rem;
  color: white;
}
.social-links-bottom .social-link:hover {
  background: #60a5fa;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(96, 165, 250, 0.4);
}

@media (max-width: 992px) {
  .hero-content {
    text-align: center;
    padding: 2rem 1rem;
  }
  .hero-content .main-title {
    font-size: 2.5rem;
  }
  .hero-content .features-list {
    align-items: center;
  }
  .hero-content .cta-group {
    justify-content: center;
    flex-wrap: wrap;
  }
  .hero-content .stats-container {
    justify-content: center;
  }
  .social-links {
    justify-content: center;
  }
  .social-links-bottom {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
  }
  .social-links-bottom .social-link {
    width: 40px;
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/landing-page/landing-page.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iNAAA;EACA,YAAA;EACA,oCAAA;AACJ;;AAGA;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAEI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mCAAA;UAAA,2BAAA;EACA,iBAAA;AAAN;AAEM;EACE,cAAA;AAAR;AAKE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAHJ;AAKI;EACE,qDAAA;EACA,6BAAA;EACA,oCAAA;AAHN;AAOE;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AANN;AAQM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;AANR;AAQQ;EACE,cAAA;EACA,eAAA;AANV;AAYE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAVJ;AAYI;EACE,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAVN;AAYM;EACE,oBAAA;AAVR;AAcI;EACE,sCAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAZN;AAcM;EACE,oBAAA;AAZR;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAfJ;AAiBI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAfN;AAiBM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAfR;AAkBM;EACE,iBAAA;EACA,+BAAA;AAhBR;AAmBM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAjBR;AAmBQ;EACE,cAAA;AAjBV;AAsBI;EACE,UAAA;EACA,YAAA;EACA,oCAAA;AApBN;;AAyBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAtBF;AAwBE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAtBJ;AAyBE;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,iDAAA;AAvBJ;AAyBI;EACE,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AAvBN;AAyBM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAvBR;AAyBQ;EACE,aAAA;EACA,WAAA;EACA,cAAA;AAvBV;AA2BM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAzBR;AA0BQ;EACE,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,6CAAA;AAxBV;AA0BU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;AAxBZ;AA0BY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAxBd;AA2BY;EACE,OAAA;AAzBd;AA2Bc;EACE,gBAAA;EACA,SAAA;AAzBhB;AA4Bc;EACE,cAAA;EACA,iBAAA;EACA,SAAA;AA1BhB;AA8BY;EACE,gBAAA;EACA,cAAA;AA5Bd;AAgCU;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AA9BZ;AAgCY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AA9Bd;AAgCc;EACE,cAAA;AA9BhB;AAuCE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AArCJ;AAuCI;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,+CAAA;EACA,wCAAA;AArCN;AAuCM;EACE,QAAA;EACA,YAAA;EACA,mBAAA;AArCR;AAwCM;EACE,QAAA;EACA,WAAA;EACA,mBAAA;AAtCR;AAyCM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAvCR;;AA6CA;EACE;IAAW,wBAAA;EAzCX;EA0CA;IAAM,4BAAA;EAvCN;AACF;AAyCA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AAvCF;AAyCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,yBAAA;AAvCJ;AAyCI;EACE,kBAAA;EACA,YAAA;AAvCN;AA0CI;EACE,mBAAA;EACA,2BAAA;AAxCN;;AA6CA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AA1CF;AA4CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,yBAAA;EACA,yCAAA;AA1CJ;AA4CI;EACE,kBAAA;EACA,YAAA;AA1CN;AA6CI;EACE,mBAAA;EACA,2BAAA;EACA,8CAAA;AA3CN;;AAgDA;EACE;IACE,kBAAA;IACA,kBAAA;EA7CF;EA+CE;IACE,iBAAA;EA7CJ;EAgDE;IACE,mBAAA;EA9CJ;EAiDE;IACE,uBAAA;IACA,eAAA;EA/CJ;EAkDE;IACE,uBAAA;EAhDJ;EAoDA;IACE,uBAAA;EAlDF;EAqDA;IACE,eAAA;IACA,YAAA;IACA,UAAA;EAnDF;EAqDE;IACE,WAAA;IACA,YAAA;EAnDJ;AACF","sourcesContent":[".hero-container {\r\n  min-height: 100vh;\r\n  background: #161F32;\r\n  position: relative;\r\n  overflow: hidden;\r\n  padding: 0;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='1' fill='rgba(255,255,255,0.1)'/%3E%3C/svg%3E\");\r\n    opacity: 0.3;\r\n    animation: float 20s linear infinite;\r\n  }\r\n}\r\n\r\n.hero-section {\r\n  background: #161F32;\r\n  min-height: 100vh;\r\n  width: 100%;\r\n}\r\n\r\n.hero-content {\r\n  padding: 4rem 2rem;\r\n  color: white;\r\n  position: relative;\r\n  z-index: 1;\r\n\r\n  .badge-wrapper {\r\n    margin-bottom: 2rem;\r\n\r\n    .badge {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      padding: 0.5rem 1rem;\r\n      background: rgba(255, 255, 255, 0.1);\r\n      border-radius: 2rem;\r\n      backdrop-filter: blur(10px);\r\n      font-size: 0.9rem;\r\n      \r\n      ion-icon {\r\n        color: #60a5fa;\r\n      }\r\n    }\r\n  }\r\n\r\n  .main-title {\r\n    font-size: 3.5rem;\r\n    font-weight: 800;\r\n    line-height: 1.2;\r\n    margin-bottom: 1.5rem;\r\n\r\n    .highlight {\r\n      background: linear-gradient(120deg, #60a5fa, #818cf8);\r\n      -webkit-background-clip: text;\r\n      -webkit-text-fill-color: transparent;\r\n    }\r\n  }\r\n\r\n  .subtitle {\r\n    font-size: 1.2rem;\r\n    line-height: 1.6;\r\n    color: rgba(255, 255, 255, 0.8);\r\n    margin-bottom: 2.5rem;\r\n    max-width: 600px;\r\n  }\r\n\r\n  .features-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    margin-bottom: 3rem;\r\n\r\n    .feature-item {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 1rem;\r\n\r\n      .check-icon {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        width: 24px;\r\n        height: 24px;\r\n        background: rgba(96, 165, 250, 0.2);\r\n        border-radius: 50%;\r\n\r\n        ion-icon {\r\n          color: #60a5fa;\r\n          font-size: 1rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .cta-group {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 3rem;\r\n\r\n    .primary-btn {\r\n      --background: #60a5fa;\r\n      --padding-start: 2rem;\r\n      --padding-end: 2rem;\r\n      --border-radius: 2rem;\r\n      height: 3.5rem;\r\n      font-weight: 600;\r\n      \r\n      ion-icon {\r\n        margin-right: 0.5rem;\r\n      }\r\n    }\r\n\r\n    .secondary-btn {\r\n      --background: rgba(255, 255, 255, 0.1);\r\n      --padding-start: 2rem;\r\n      --padding-end: 2rem;\r\n      --border-radius: 2rem;\r\n      height: 3.5rem;\r\n      font-weight: 600;\r\n      \r\n      ion-icon {\r\n        margin-right: 0.5rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .stats-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 2rem;\r\n\r\n    .stat-item {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n\r\n      .stat-number {\r\n        font-size: 1.5rem;\r\n        font-weight: 700;\r\n        color: #60a5fa;\r\n      }\r\n\r\n      .stat-label {\r\n        font-size: 0.9rem;\r\n        color: rgba(255, 255, 255, 0.6);\r\n      }\r\n\r\n      .rating {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.25rem;\r\n        \r\n        ion-icon {\r\n          color: #fbbf24;\r\n        }\r\n      }\r\n    }\r\n\r\n    .stat-divider {\r\n      width: 1px;\r\n      height: 40px;\r\n      background: rgba(255, 255, 255, 0.2);\r\n    }\r\n  }\r\n}\r\n\r\n.visual-container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4rem 2rem;\r\n\r\n  .app-preview {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: 400px;\r\n    height: 500px;\r\n  }\r\n\r\n  .phone-frame {\r\n    height: 100%;\r\n    background: white;\r\n    border-radius: 3rem;\r\n    padding: 1rem;\r\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n\r\n    .screen {\r\n      background: #f8fafc;\r\n      border-radius: 2.5rem;\r\n      overflow: hidden;\r\n      padding: 1rem;\r\n\r\n      .app-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        margin-bottom: 2rem;\r\n\r\n        .status-icons {\r\n          display: flex;\r\n          gap: 0.5rem;\r\n          color: #64748b;\r\n        }\r\n      }\r\n\r\n      .app-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 40px;\r\n        .session-card {\r\n          background: white;\r\n          border-radius: 1.5rem;\r\n          padding: 1.5rem;\r\n          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n\r\n          .user-info {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 1rem;\r\n            margin-bottom: 1.5rem;\r\n\r\n            .avatar {\r\n              width: 48px;\r\n              height: 48px;\r\n              border-radius: 50%;\r\n              background: #60a5fa;\r\n            }\r\n\r\n            .details {\r\n              flex: 1;\r\n\r\n              h3 {\r\n                font-weight: 600;\r\n                margin: 0;\r\n              }\r\n\r\n              p {\r\n                color: #64748b;\r\n                font-size: 0.9rem;\r\n                margin: 0;\r\n              }\r\n            }\r\n\r\n            .progress {\r\n              font-weight: 700;\r\n              color: #60a5fa;\r\n            }\r\n          }\r\n\r\n          .session-stats {\r\n            display: grid;\r\n            grid-template-columns: 1fr 1fr;\r\n            gap: 1rem;\r\n\r\n            .stat {\r\n              display: flex;\r\n              align-items: center;\r\n              gap: 0.5rem;\r\n              font-size: 0.9rem;\r\n              color: #64748b;\r\n\r\n              ion-icon {\r\n                color: #60a5fa;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .floating-elements {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n\r\n    .float-card {\r\n      position: absolute;\r\n      background: white;\r\n      padding: 0.75rem 1rem;\r\n      border-radius: 1rem;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      font-size: 0.9rem;\r\n      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\r\n      animation: float 6s ease-in-out infinite;\r\n\r\n      &.progress-card {\r\n        top: 20%;\r\n        right: -20px;\r\n        animation-delay: 0s;\r\n      }\r\n\r\n      &.notification-card {\r\n        top: 50%;\r\n        left: -20px;\r\n        animation-delay: 2s;\r\n      }\r\n\r\n      &.schedule-card {\r\n        bottom: 20%;\r\n        right: -20px;\r\n        animation-delay: 4s;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes float {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-10px); }\r\n}\r\n\r\n.social-links {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n  margin-bottom: 3rem;\r\n\r\n  .social-link {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    backdrop-filter: blur(10px);\r\n    transition: all 0.3s ease;\r\n\r\n    ion-icon {\r\n      font-size: 1.25rem;\r\n      color: white;\r\n    }\r\n\r\n    &:hover {\r\n      background: #60a5fa;\r\n      transform: translateY(-3px);\r\n    }\r\n  }\r\n}\r\n\r\n.social-links-bottom {\r\n  position: fixed;\r\n  bottom: 2rem;\r\n  left: 2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  z-index: 1000;\r\n\r\n  .social-link {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 45px;\r\n    height: 45px;\r\n    border-radius: 50%;\r\n    background: rgba(255, 255, 255, 0.15);\r\n    backdrop-filter: blur(10px);\r\n    transition: all 0.3s ease;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\r\n\r\n    ion-icon {\r\n      font-size: 1.25rem;\r\n      color: white;\r\n    }\r\n\r\n    &:hover {\r\n      background: #60a5fa;\r\n      transform: translateY(-3px);\r\n      box-shadow: 0 6px 20px rgba(96, 165, 250, 0.4);\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .hero-content {\r\n    text-align: center;\r\n    padding: 2rem 1rem;\r\n\r\n    .main-title {\r\n      font-size: 2.5rem;\r\n    }\r\n\r\n    .features-list {\r\n      align-items: center;\r\n    }\r\n\r\n    .cta-group {\r\n      justify-content: center;\r\n      flex-wrap: wrap;\r\n    }\r\n\r\n    .stats-container {\r\n      justify-content: center;\r\n    }\r\n  }\r\n\r\n  .social-links {\r\n    justify-content: center;\r\n  }\r\n\r\n  .social-links-bottom {\r\n    position: fixed;\r\n    bottom: 1rem;\r\n    left: 1rem;\r\n    \r\n    .social-link {\r\n      width: 40px;\r\n      height: 40px;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
